import { SearchTerm } from "./SearchTerm";

const DeviceScheduleSearch: SearchTerm[] = [
    {
        heading: "Mode",
        accessor: "mode",
        searchOnName: "settingType.trnName",
        translationKey: "mode"
    },
];

export default DeviceScheduleSearch;
